export { default } from './NavMain';
